
import { Options, Vue } from "vue-class-component"; //基本需要\

import roma from "../assets/json1/roma.js";
import * as echarts from "echarts";
import passion1 from "@/assets/js/passion1.js";
import { store } from "@/store"; //引入仓库
import { ElMessage } from "element-plus";
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import {
  dispatchGetSkinManagement,
  dispatchGetSkinLineView,
  dispatchUpdateSkinLineView,
  dispatchGetSkinLinePkg,
  dispatchGetSkinLineDate,
  dispatchAbdDateOptions,
  dispatchAbdDeviceptions,
  dispatchAbdSceneOptions,
  dispatchAbdSubtypeOptions,
  dispatchAbdList,
  dispatchAbdType,
  dispatchAbdProcess,
  dispatchAbdSum,
  dispatchAbdLog,
  dispatchAbdDateSingle,
  dispatchAbdCompare,
  dispatchLightPerfDate,
  dispatchAndroidAppDate,
  dispatchAndroidAppDevice,
  dispatchAndroidAppScene,
  dispatchAndroidAppSubtype,
  dispatchAndroidAppLog,
  dispatchAndroidAppFileData,
  dispatchLightPerfDevice,
  dispatchLightPerfScene,
  dispatchLightPerfSubtype,
  dispatchLightPerfLog,
  dispatchLightResource,
  dispatchLightJank,
  dispatchLightMethod,
  dispatchLightPerfTrend,
  dispatchLightPerfFunctions,
  dispatchLightPerfDateContrast,
  dispatchAndroidAppDateContrast,
  dispatchLightPerfResourceCost,
  dispatchLightPerfJankCost,
  dispatchLightPerfMethodCost,
  dispatchAndroidAppFileCompare,
  dispatchAndroidAppFilename,
  dispatchAndroidAppFileTrend,
  dispatchAndroidAppZip,
  dispatchAndroidAppFileUrl,
  dispatchDeleteFile,
} from "@/store/performance/actions";
// import God from "@/assets/js/god.js";
import {
  readGetAndroidAppDate,
  readGetAndroidAppDevice,
  readGetAndroidAppScene,
  readGetAndroidAppSubtype,
  readGetAndroidAppLog,
  readGetLightPerfDevice,
  readGetAndroidAppFileTrend,
  readGetLightPerfScene,
  readGetLightPerfSubtype,
  readGetLightPerfLog,
  readGetAndroidAppFileData,
  readGetLightPerfResource,
  readGetLightPerfJank,
  readGetLightPerfMethod,
  readGetLightPerfFunctions,
  readGetLightPerfTrend,
  readGetAndroidAppFilename,
  readGetLightPerfDateContrast,
  readGetAndroidAppDateContrast,
  readGetLightPerfResourContrast,
  readGetLightPerfJankContrast,
  readGetLightPerfMethodContrast,
  readGetAndroidAppDateFileCompare,
  readGetAndroidAppZip,
  readGetAndroidAppFileUrl,
} from "@/store/performance/getters";
export default class TestReport extends Vue {
  public localProject = Number(getLocalProject()); //得到本地的项目
  public ResourceTableLoading = false;
  public loading = false;
  public trendLoading = false;
  public async mounted() {
    this.ResourceTableLoading = true;
    this.loading = true;
    this.trendLoading = true;
    // await dispatchLightPerfDate(store, {
    //   project: this.localProject,
    // });
    await dispatchAndroidAppDate(store, {
      project: this.localProject,
    });
    this.filterList.date = readGetAndroidAppDate(store)[0].date;
    // await dispatchLightPerfDevice(store, {
    //   project: this.localProject,
    //   date: this.filterList.date,
    // });
    await dispatchAndroidAppDevice(store, {
      project: this.localProject,
      date: this.filterList.date,
    });
    
    const option = readGetAndroidAppDevice(store).find(item => item.name.includes('J200')) || readGetAndroidAppDevice(store)[0]
    this.filterList.device = option?.device_id;

    // await dispatchLightPerfScene(store, {
    //   project: this.localProject,
    //   date: this.filterList.date,
    //   device_id: Number(this.filterList.device),
    // });
    await dispatchAndroidAppScene(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
    });
    this.filterList.scene = readGetAndroidAppScene(store)[0].id;
    await dispatchAndroidAppSubtype(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
    });

    this.filterList.subtype = readGetAndroidAppSubtype(store)[0].subtype;
    await dispatchAndroidAppLog(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
      subtype: Number(this.filterList.subtype),
    });

    this.filterList.Journa = readGetAndroidAppLog(store)[0].id_test;
    await dispatchAndroidAppZip(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });
    await dispatchAndroidAppDateContrast(store, {
      project: this.localProject,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
      subtype: Number(this.filterList.subtype),
    });
    this.filterList.dateResource.push(this.filterList.date);
    let num = 0;
    readGetAndroidAppDateContrast(store).forEach((v, index) => {
      if (v.date === this.filterList.date) {
        num = index;
      }
    });
    if (readGetAndroidAppDateContrast(store).length > 1) {
      if (num == readGetAndroidAppDateContrast(store).length - 1) {
        this.filterList.dateResource.push(
          readGetAndroidAppDateContrast(store)[num - 1].date
        );
      } else {
        this.filterList.dateResource.push(
          readGetAndroidAppDateContrast(store)[num + 1].date
        );
      }
    }

    // this.filterList.dateMethod.push(this.filterList.date);
    // this.filterList.dateJank.push(this.filterList.date);
    await dispatchAndroidAppFileData(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.resource_input,
      size: this.record,
      page: this.currentPage1,
    });
    this.loading = false;
    await dispatchAndroidAppFileCompare(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.dateResource,
    });
    // await dispatchLightJank(store, {
    //   project: this.localProject,
    //   id_test: Number(this.filterList.Journa),
    //   search: this.jank_input,
    //   size: this.record,
    //   page: this.currentPage2,
    // });
    // await dispatchLightPerfJankCost(store, {
    //   project: this.localProject,
    //   id_test: Number(this.filterList.Journa),
    //   date_list: this.filterList.dateJank,
    // });
    // await dispatchLightMethod(store, {
    //   project: this.localProject,
    //   id_test: Number(this.filterList.Journa),
    //   search: this.method_input,
    //   size: this.record,
    //   page: this.currentPage3,
    // });
    // await dispatchLightPerfMethodCost(store, {
    //   project: this.localProject,
    //   id_test: Number(this.filterList.Journa),
    //   date_list: this.filterList.dateMethod,
    // });

    this.ResourceTable.results = this.resourceList.list.slice(
      (this.currentPage4 - 1) * 10,
      this.currentPage4 * 10
    );
    this.ResourceTableLoading = false;
    // this.JankTable.results = this.jankList.list.slice(
    //   (this.currentPage6 - 1) * 10,
    //   this.currentPage6 * 10
    // );
    // this.MethodTable.results = this.methodList.list.slice(
    //   (this.currentPage5 - 1) * 10,
    //   this.currentPage5 * 10
    // );

    await dispatchAndroidAppFilename(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });

    this.filterList.trendOp = this.lightPerfFunctions?.filenames[0].file_name;
    await dispatchAndroidAppFileUrl(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });
    await dispatchAndroidAppFileTrend(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      file_name: this.filterList.trendOp,
    });
    await this.drawTrend();
    this.trendLoading = false;
  }
  public get resourceList() {
    return readGetAndroidAppDateFileCompare(store);
  }
  public get lightUrl() {
    return readGetAndroidAppFileUrl(store);
  }
  public get methodList() {
    return readGetLightPerfMethodContrast(store);
  }
  public get jankList() {
    return readGetLightPerfJankContrast(store);
  }
  public async cost(type) {
    this.ResourceTableLoading = true;
    if (type === "jank") {
      this.currentPage6 = 1;
      await dispatchLightPerfJankCost(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateJank,
      });
      this.JankTable.results = this.jankList.list.slice(
        (this.currentPage6 - 1) * 10,
        this.currentPage6 * 10
      );
    }
    if (type === "resource") {
      this.currentPage4 = 1;
      await dispatchAndroidAppFileCompare(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateResource,
      });
      this.ResourceTable.results = this.resourceList.list.slice(
        (this.currentPage4 - 1) * 10,
        this.currentPage4 * 10
      );
    }
    if (type === "method") {
      this.currentPage5 = 1;
      await dispatchLightPerfMethodCost(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        date_list: this.filterList.dateMethod,
      });
      this.MethodTable.results = this.methodList.list.slice(
        (this.currentPage5 - 1) * 10,
        this.currentPage5 * 10
      );
    }
    this.ResourceTableLoading = false;
  }
  public ResourceTable: any = {
    results: [],
    count: 0,
  };
  public MethodTable: any = {
    results: [],
    count: 0,
  };
  public JankTable: any = {
    results: [],
    count: 0,
  };
  public get appZip() {
    return readGetAndroidAppZip(store);
  }
  public resource_input = "";
  public jank_input = "";
  public method_input = "";
  public record = 10;
  public currentPage1 = 1;
  public currentPage2 = 1;
  public currentPage3 = 1;
  public currentPage4 = 1;
  public currentPage5 = 1;
  public currentPage6 = 1;
  public filterList = {
    date: "",
    device: "",
    scene: "",
    subtype: "",
    Journa: "",
    trendOp: "",
    dateResource: [],
    dateMethod: [],
    dateJank: [],
  };
  public async recordSearch(type) {
    this.loading = true;
    if (type === "resource_input") {
      this.currentPage1 = 1;
      await dispatchAndroidAppFileData(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.resource_input,
        size: this.record,
        page: this.currentPage1,
      });
    }
    if (type === "jank_input") {
      this.currentPage2 = 1;
      await dispatchLightJank(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.jank_input,
        size: this.record,
        page: this.currentPage2,
      });
    }
    if (type === "method_input") {
      this.currentPage3 = 1;
      await dispatchLightMethod(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.method_input,
        size: this.record,
        page: this.currentPage3,
      });
    }
    this.loading = false;
  }
  public async handleCurrentChange1(type) {
    this.ResourceTableLoading = true;
    if (type === "resource_input") {
      this.ResourceTable.results = this.resourceList.list.slice(
        (this.currentPage4 - 1) * 10,
        this.currentPage4 * 10
      );
    }
    if (type === "jank_input") {
      this.JankTable.results = this.jankList.list.slice(
        (this.currentPage6 - 1) * 10,
        this.currentPage6 * 10
      );
    }
    if (type === "method_input") {
      this.MethodTable.results = this.methodList.list.slice(
        (this.currentPage5 - 1) * 10,
        this.currentPage5 * 10
      );
    }
    this.ResourceTableLoading = false;
  }
  public async deleteBtn() {
    this.ResourceTableLoading = true;
    this.loading = true;
    this.trendLoading = true;
    await dispatchDeleteFile(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });
    await dispatchAndroidAppDate(store, {
      project: this.localProject,
    });
    this.filterList.date = readGetAndroidAppDate(store)[0].date;
    // await dispatchLightPerfDevice(store, {
    //   project: this.localProject,
    //   date: this.filterList.date,
    // });
    await dispatchAndroidAppDevice(store, {
      project: this.localProject,
      date: this.filterList.date,
    });
    this.filterList.device = readGetAndroidAppDevice(store)[0].device_id;
    // await dispatchLightPerfScene(store, {
    //   project: this.localProject,
    //   date: this.filterList.date,
    //   device_id: Number(this.filterList.device),
    // });
    await dispatchAndroidAppScene(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
    });
    this.filterList.scene = readGetAndroidAppScene(store)[0].id;
    await dispatchAndroidAppSubtype(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
    });

    this.filterList.subtype = readGetAndroidAppSubtype(store)[0].subtype;
    await dispatchAndroidAppLog(store, {
      project: this.localProject,
      date: this.filterList.date,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
      subtype: Number(this.filterList.subtype),
    });

    this.filterList.Journa = readGetAndroidAppLog(store)[0].id_test;
    await dispatchAndroidAppZip(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });
    await dispatchAndroidAppDateContrast(store, {
      project: this.localProject,
      device_id: Number(this.filterList.device),
      scene_id: Number(this.filterList.scene),
      subtype: Number(this.filterList.subtype),
    });
    this.filterList.dateResource = [];
    this.filterList.dateMethod = [];
    this.filterList.dateJank = [];
    this.filterList.dateResource.push(this.filterList.date);
    let num = 0;
    readGetAndroidAppDateContrast(store).forEach((v, index) => {
      if (v.date === this.filterList.date) {
        num = index;
      }
    });
    if (readGetAndroidAppDateContrast(store).length > 1) {
      if (num == readGetAndroidAppDateContrast(store).length - 1) {
        this.filterList.dateResource.push(
          readGetAndroidAppDateContrast(store)[num - 1].date
        );
      } else {
        this.filterList.dateResource.push(
          readGetAndroidAppDateContrast(store)[num + 1].date
        );
      }
    }
    this.currentPage1 = 1;
    this.currentPage2 = 1;
    this.currentPage3 = 1;
    this.currentPage4 = 1;
    this.currentPage5 = 1;
    this.currentPage6 = 1;

    // this.filterList.dateMethod.push(this.filterList.date);
    // this.filterList.dateJank.push(this.filterList.date);
    await dispatchAndroidAppFileData(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.resource_input,
      size: this.record,
      page: this.currentPage1,
    });
    this.loading = false;
    await dispatchAndroidAppFileCompare(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.dateResource,
    });
    // await dispatchLightJank(store, {
    //   project: this.localProject,
    //   id_test: Number(this.filterList.Journa),
    //   search: this.jank_input,
    //   size: this.record,
    //   page: this.currentPage2,
    // });
    // await dispatchLightPerfJankCost(store, {
    //   project: this.localProject,
    //   id_test: Number(this.filterList.Journa),
    //   date_list: this.filterList.dateJank,
    // });
    // await dispatchLightMethod(store, {
    //   project: this.localProject,
    //   id_test: Number(this.filterList.Journa),
    //   search: this.method_input,
    //   size: this.record,
    //   page: this.currentPage3,
    // });
    // await dispatchLightPerfMethodCost(store, {
    //   project: this.localProject,
    //   id_test: Number(this.filterList.Journa),
    //   date_list: this.filterList.dateMethod,
    // });

    this.ResourceTable.results = this.resourceList.list.slice(
      (this.currentPage4 - 1) * 10,
      this.currentPage4 * 10
    );
    this.ResourceTableLoading = false;
    // this.JankTable.results = this.jankList.list.slice(
    //   (this.currentPage6 - 1) * 10,
    //   this.currentPage6 * 10
    // );
    // this.MethodTable.results = this.methodList.list.slice(
    //   (this.currentPage5 - 1) * 10,
    //   this.currentPage5 * 10
    // );

    await dispatchAndroidAppFilename(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });

    this.filterList.trendOp = this.lightPerfFunctions?.filenames[0].file_name;
    await dispatchAndroidAppFileUrl(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });
    await dispatchAndroidAppFileTrend(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      file_name: this.filterList.trendOp,
    });
    await this.drawTrend();
    this.trendLoading = false;
  }
  public async handleCurrentChange(type) {
    this.loading = true;
    if (type === "resource_input") {
      await dispatchAndroidAppFileData(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.resource_input,
        size: this.record,
        page: this.currentPage1,
      });
    }
    if (type === "jank_input") {
      await dispatchLightJank(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.jank_input,
        size: this.record,
        page: this.currentPage2,
      });
    }
    if (type === "method_input") {
      await dispatchLightMethod(store, {
        project: this.localProject,
        id_test: Number(this.filterList.Journa),
        search: this.method_input,
        size: this.record,
        page: this.currentPage3,
      });
    }
    this.loading = false;
  }
  public get dateOptions() {
    return readGetAndroidAppDate(store);
  }
  public get deviceOptions() {
    return readGetAndroidAppDevice(store);
  }
  public get sceneOptions() {
    return readGetAndroidAppScene(store);
  }
  public get subtypeOptions() {
    return readGetAndroidAppSubtype(store);
  }
  public get JournaOptions() {
    return readGetAndroidAppLog(store);
  }
  public get lightPerfResource() {
    return readGetAndroidAppFileData(store);
  }
  // public get lightPerfJank() {
  //   return readGetLightPerfJank(store);
  // }
  // public get lightPerfmethod() {
  //   return readGetLightPerfMethod(store);
  // }
  public get lightPerfFunctions() {
    return readGetAndroidAppFilename(store);
  }
  public get lightPerfTrend() {
    return readGetAndroidAppFileTrend(store);
  }
  public get lightPerfDateContrast() {
    return readGetAndroidAppDateContrast(store);
  }
  public async allOption(item) {
    this.ResourceTableLoading = true;
    this.loading = true;
    for (let v of item) {
      if (v === "device") {
        await dispatchAndroidAppDevice(store, {
          project: this.localProject,
          date: this.filterList.date,
        });

        const defaultOption = readGetAndroidAppDevice(store).find(item => item.name.includes('J200')) || readGetAndroidAppDevice(store)[0]
        this.filterList.device = defaultOption?.device_id;
      }
      if (v === "scene") {
        await dispatchAndroidAppScene(store, {
          project: this.localProject,
          date: this.filterList.date,
          device_id: Number(this.filterList.device),
        });
        this.filterList.scene = readGetAndroidAppScene(store)[0].id;
      }
      if (v === "subtype") {
        await dispatchAndroidAppSubtype(store, {
          project: this.localProject,
          date: this.filterList.date,
          device_id: Number(this.filterList.device),
          scene_id: Number(this.filterList.scene),
        });
        this.filterList.subtype = readGetAndroidAppSubtype(store)[0].subtype;
      }
      if (v === "log") {
        await dispatchAndroidAppLog(store, {
          project: this.localProject,
          date: this.filterList.date,
          device_id: Number(this.filterList.device),
          scene_id: Number(this.filterList.scene),
          subtype: Number(this.filterList.subtype),
        });

        this.filterList.Journa = readGetAndroidAppLog(store)[0].id_test;
      }
      if (v === "dateContrast") {
        await dispatchAndroidAppDateContrast(store, {
          project: this.localProject,
          device_id: Number(this.filterList.device),
          scene_id: Number(this.filterList.scene),
          subtype: Number(this.filterList.subtype),
        });
        this.filterList.dateResource = [];
        this.filterList.dateMethod = [];
        this.filterList.dateJank = [];
        this.filterList.dateResource.push(this.filterList.date);
        let num = 0;
        readGetAndroidAppDateContrast(store).forEach((v, index) => {
          if (v.date === this.filterList.date) {
            num = index;
          }
        });
        if (readGetAndroidAppDateContrast(store).length > 1) {
          if (num == readGetAndroidAppDateContrast(store).length - 1) {
            this.filterList.dateResource.push(
              readGetAndroidAppDateContrast(store)[num - 1].date
            );
          } else {
            this.filterList.dateResource.push(
              readGetAndroidAppDateContrast(store)[num + 1].date
            );
          }
        }
        // this.filterList.dateMethod.push(this.filterList.date);
        // this.filterList.dateJank.push(this.filterList.date);
        this.currentPage1 = 1;
        this.currentPage2 = 1;
        this.currentPage3 = 1;
        this.currentPage4 = 1;
        this.currentPage5 = 1;
        this.currentPage6 = 1;
      }
    }
    await dispatchAndroidAppZip(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });
    await dispatchAndroidAppFileData(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      search: this.resource_input,
      size: this.record,
      page: this.currentPage1,
    });

    this.loading = false;
    await dispatchAndroidAppFileCompare(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      date_list: this.filterList.dateResource,
    });
    //     await dispatchLightJank(store, {
    //       project: this.localProject,
    //       id_test: Number(this.filterList.Journa),
    //       search: this.jank_input,
    //       size: this.record,
    //       page: this.currentPage2,
    //     });
    //     await dispatchLightPerfJankCost(store, {
    //       project: this.localProject,
    //       id_test: Number(this.filterList.Journa),
    //       date_list: this.filterList.dateJank,
    //     });
    //     await dispatchLightMethod(store, {
    //       project: this.localProject,
    //       id_test: Number(this.filterList.Journa),
    //       search: this.method_input,
    //       size: this.record,
    //       page: this.currentPage3,
    //     });
    //     await dispatchLightPerfMethodCost(store, {
    //       project: this.localProject,
    //       id_test: Number(this.filterList.Journa),
    //       date_list: this.filterList.dateMethod,
    //     });
    this.ResourceTable.results = this.resourceList.list.slice(
      (this.currentPage4 - 1) * 10,
      this.currentPage4 * 10
    );
    this.ResourceTableLoading = false;
    //     this.JankTable.results = this.jankList.list.slice(
    //       (this.currentPage6 - 1) * 10,
    //       this.currentPage6 * 10
    //     );
    //     this.MethodTable.results = this.methodList.list.slice(
    //       (this.currentPage5 - 1) * 10,
    //       this.currentPage5 * 10
    //     );
    await dispatchAndroidAppFilename(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });
    this.filterList.trendOp = this.lightPerfFunctions?.filenames[0].file_name;
    await dispatchAndroidAppFileUrl(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
    });
    await dispatchAndroidAppFileTrend(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      file_name: this.filterList.trendOp,
    });
    await this.drawTrend();
  }
  // public  cellStyle({row, column, rowIndex, columnIndex}){
  //   console.log(column)
  //   //     if(rowIndex === 1 && columnIndex === 2){ //指定坐标rowIndex ：行，columnIndex ：列
  //   //     return 'background:red' //rgb(105,0,7)
  //   // }else{
  //   //     return ''
  //   // }
  //   }
  public packageBtn() {
    if (this.lightUrl === "") {
      ElMessage.error("无对应的流水线");
    } else {
      window.open(this.lightUrl, "_blank");
    }
  }
  public getCom(newValue, oldValue) {
    if (newValue > oldValue) {
      return "(" + (newValue - oldValue) + "↓)";
    }
    if (newValue === oldValue) {
      return "(--)";
    }
    if (newValue < oldValue) {
      return "(" + (oldValue - newValue) + "↑)";
    }
  }
  public async allOption1() {
    this.trendLoading = true;
    await dispatchAndroidAppFileTrend(store, {
      project: this.localProject,
      id_test: Number(this.filterList.Journa),
      file_name: this.filterList.trendOp,
    });
    await this.drawTrend();
    this.trendLoading = false;
  }
  public drawTrend() {
    let ordinates: any[] = [];
    this.lightPerfTrend.trend_data.device_list.forEach((v, index) => {
      ordinates.push({
        name: v,
        type: "line",
        data: this.lightPerfTrend.trend_data.series[index],
        smooth: true, // 平滑曲线
        symbol: "circle", //拐点设置为实心
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
      });
    });
    let performance_line: any = document.getElementById("performance_line");
    echarts.dispose(performance_line);
    let PerformanceLineChart = echarts.init(performance_line);
    let option;
    option = {
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
        formatter: function (params) {
          //  只粘贴formatter了

          let relVal = params[0].axisValueLabel;
          for (let i = 0; i < params.length; i++) {
            relVal +=
              "<br />" +
              params[i].marker +
              params[i].seriesName +
              '<span style="font-weight:bold;float:right">' +
              (params[i].value == undefined ? "-" : params[i].value) + //   不同点
              "(Byte)" +
              "</span>";
          }

          return relVal;
        },
      },
      legend: {
        x: "center",
        y: "bottom",
        type: "scroll",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },

      animation: false,
      series: ordinates,
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value}(Byte)",
        },
      },
      xAxis: {
        type: "category",
        data: this.lightPerfTrend.trend_data.date,
      },
    };
    PerformanceLineChart.setOption(option);
  }
}
